import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit {
  cookiesAccepted: boolean = false;
  private readonly COOKIE_CONSENT_KEY = 'movielearning_cookie_consent';
  private readonly LOCALSTORAGE_KEY = 'movielearning_cookie_consent_ls';

  constructor(private cookieService: CookieService) { }

  ngOnInit(): void {
    this.checkCookieConsent();
  }

  private checkCookieConsent(): void {
    // Verificar tanto la cookie como localStorage
    const cookieExists = this.cookieService.check(this.COOKIE_CONSENT_KEY);
    const localStorageExists = localStorage.getItem(this.LOCALSTORAGE_KEY) === 'true';
    
    this.cookiesAccepted = cookieExists || localStorageExists;
    
    console.log('Checking cookie consent:', {
      cookie: cookieExists,
      localStorage: localStorageExists,
      accepted: this.cookiesAccepted
    });
  }

  acceptCookies(): void {
    // Set cookie to expire in 365 days
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    
    // Guardar tanto en cookie como en localStorage como respaldo
    try {
      this.cookieService.set(
        this.COOKIE_CONSENT_KEY, 
        'true', 
        expiryDate,
        '/' // path
      );
    } catch (error) {
      console.warn('Could not set cookie:', error);
    }
    
    // Usar localStorage como fallback
    localStorage.setItem(this.LOCALSTORAGE_KEY, 'true');
    
    this.cookiesAccepted = true;
    
    console.log('Cookie consent saved:', {
      cookie: this.cookieService.get(this.COOKIE_CONSENT_KEY),
      localStorage: localStorage.getItem(this.LOCALSTORAGE_KEY)
    });
  }
}